import Tippy from "@tippyjs/react";
import { Icon } from "components/icon";
import Flags from "flags";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { selectTool } from "tools";
import { Consts } from "vars";
import { Hint } from "../../view/tooltips";
const toolMenuItems = [
    {
        name: "select",
        icon: "mouse-pointer",
        shortcut: { key: "1" },
        shortcut2: { key: "V" },
    },
    {
        name: "pan",
        icon: "arrows-alt",
        shortcut: { key: "2" },
        shortcut2: { key: "P" },
    },
    {
        name: "arrow",
        icon: "font", // other options are fa-long-arrow-alt-right or fa-tag
        shortcut: { key: "3" },
        shortcut2: { key: "T" },
    },
];
if (Flags.isFreeHandToolEnabled) {
    toolMenuItems.push({
        name: "freehand",
        icon: "pencil-alt",
        shortcut: { key: "4" },
        shortcut2: { key: "D" }
    });
}
if (Consts.isDev) {
    toolMenuItems.push({
        name: "pathedit",
        icon: "bezier-curve",
    });
}
/**
 * Toolbox is a button group that allows the user
 * to select a tool. Unlike a regular "group of buttons",
 * toolbox highlights the currently selected tool and only
 * one tool can be selected.
 */
export const Toolbox = (props) => (React.createElement("div", { id: "toolbox", className: "horizontal-button-group", key: "toolbox" }, toolMenuItems.map(i => React.createElement(Item, Object.assign({ key: i.name }, i, { active: props.tool === i.name })))));
const Item = (item) => {
    const { t } = useTranslation();
    return React.createElement(Tippy, { content: React.createElement(Hint, { text: t("tool." + item.name), shortcut: item.shortcut, shortcut2: item.shortcut2 }) },
        React.createElement("div", { key: item.name, id: `tool-${item.name}`, className: "ui-button " + (item.active ? "highlight" : ""), onClick: () => selectTool(item.name, "click") },
            React.createElement(Icon, { name: item.icon, fullWidth: true })));
};
